module.exports = __webpack_public_path__ + "img/changeGrooves-2.618d3b1.png";